import { theme } from 'aimo-ui';
import Sheet from 'components/sheets/Sheet';
import React from 'react';
import ParkingZoneSearch from '../ParkingZoneSearch';

const PermitSearchSheet: React.FC<{
  isTesting?: boolean;
}> = ({ isTesting }) => {
  return (
    <Sheet
      bgColor={theme.colors.white}
      showBackDropIndex={1}
      snappingPoints={['50%', '90%']}
      animateOnMount={false}>
      <ParkingZoneSearch withLTP padding isTesting={isTesting} />
    </Sheet>
  );
};

export default PermitSearchSheet;
